//---- Automatically generated, don't update this part ----
/**
 * An OMOP PROVIDER.
 */

interface Params {
  codeSystemName: string;
  codeSystem: string;
  code: string;
  displayName: string;
}

export default class Specialty {
  constructor(params: Params) {
    this.codeSystemName = params.codeSystemName;
    this.codeSystem = params.codeSystem;
    this.code = params.code;
    this.displayName = params.displayName;
  }

  toJson() {
    return {
      codeSystemName: this.codeSystemName,
      codeSystem: this.codeSystem,
      code: this.code,
      displayName: this.displayName
    };
  }

  codeSystemName: string;

  codeSystem: string;

  code: string;

  displayName: string;

  //---- End of generated code ----
}
